<script lang="ts" setup>
provide('listType', 'ol')
</script>

<template>
  <ol class="ol">
    <slot />
  </ol>
</template>
